import commonUtil from '../../utils/commonUtil';

export const EVENTCATEGORY_LOAD = 'EVENTCATEGORY_LOAD';
export const EVENTCATEGORY_LOAD_SUCCESS = 'EVENTCATEGORY_LOAD_SUCCESS';
export const EVENTCATEGORY_LOAD_FAIL = 'EVENTCATEGORY_LOAD_FAIL';

export function isEventCategoryLoaded(globalState) {
  return globalState.eventcategory && globalState.eventcategory.loaded;
}

export function loadEventCategoryEvent() {
  const _eventCategoryInput = {};
  _eventCategoryInput.brand = commonUtil.getBrand();
  _eventCategoryInput.channel = commonUtil.getChannel();
  return {
    types: [
      EVENTCATEGORY_LOAD,
      EVENTCATEGORY_LOAD_SUCCESS,
      EVENTCATEGORY_LOAD_FAIL,
    ],
    // promise: client => client.post('/api/eventcategory'), // params not used, just shown as demonstration
    promise: (client) =>
      client.get(
        '/api/eventCategories?' +
          commonUtil.objectToQueryParams(_eventCategoryInput),
      ),
  };
}
